import { useContext } from 'react';
import {
  SnackbarContext,
  SnackbarContextType,
} from '../contexes/SnackBarProvider';

export const useSnackBar = (): SnackbarContextType => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackBar must be used within a SnackbarProvider');
  }
  return context;
};
